var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello"},[_c('h1',[_vm._v("欢迎使用评比打分系统")]),_c('p',[_vm._v("管理员请"),_c('a',{on:{"click":function($event){return _vm.$router.push('/auth/login')}}},[_vm._v("点击此处")]),_vm._v("登录，评委请扫码或通过分享的链接登录")])])
}
var staticRenderFns = []

export { render, staticRenderFns }